import React from "react";

export const AuthContext = React.createContext();

export class AuthProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            token: localStorage.getItem("token") || null,
        };
    }

    login = (token) => {
        this.setState({ token });
        console.log('assa')
        localStorage.setItem("token", token);
    };

    logout = () => {
        this.setState({ token: null });
        console.log('dadqdq')
        localStorage.removeItem("token");
    };

    render() {
        return (
            <AuthContext.Provider
                value={{
                    token: this.state.token,
                    login: this.login,
                    logout: this.logout,
                }}
            >
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}
